import { Company, Employer } from "@entities/employer";
import { TDomesticVacancyDetailPageMeta, TVacancyCard } from "@shared/cms";
import { getSlug } from "@shared/utils";
import { Button } from "@ubud-ui/react-ui-kit";
import Link from "next/link";
import { Vacancy } from "../types";
import { VacancyPlatformInfo } from "./vacancy-platform-info";

export function VacancyCompanyCard({
  employer,
  vacancy,
  meta,
  vacancyCardMeta,
}: {
  employer: Employer;
  vacancy: Vacancy;
  meta: TDomesticVacancyDetailPageMeta;
  vacancyCardMeta: TVacancyCard;
}) {
  const company = employer.employerable as Company;

  return (
    <div className="border border-gray-200 rounded-xl p-4 flex flex-col space-y-5 overflow-hidden">
      <div className="flex flex-col space-y-3">
        <div className="font-bold text-gray-700">{employer?.name || company?.name}</div>
        {company?.address && <div className="text-sm text-gray-500">{company?.address}</div>}
        {company?.industry?.name && (
          <div className="flex flex-wrap items-center">
            <span className="border border-gray-200 bg-gray-100 rounded-full text-gray-500 py-0.5 px-2 text-sm font-medium mr-2 mb-2 relative capitalize">
              {company?.industry?.name}
            </span>
          </div>
        )}
        <div>
          <Button asChild variant="link" size="sm" className="text-sm text-primary font-bold p-0 m-0 h-auto">
            <Link href={`/perusahaan/${getSlug(employer.id, employer.name)}`}>{meta.companyLinkLabel}</Link>
          </Button>
        </div>
      </div>
      <VacancyPlatformInfo meta={vacancyCardMeta.platformInfo} vacancy={vacancy} nativeClass="!-mb-4" />
    </div>
  );
}
